export const mutations = {
  setNewsList (state, newsList) {
    state.newsList = newsList
    state.isLoaded = true
  }
}
